module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-menu', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "bottom": "",
      "offset-y": ""
    }
  }, [_c('v-btn', {
    class: _vm.launchedFromClin ? 'clinButtonColor' : '',
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [(!_vm.launchedFromClin) ? _c('v-icon', [_vm._v("help")]) : _vm._e(), _vm._v(" Help\n    ")], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.showDisclaimer = true
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Disclaimer")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.showAbout = true
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("About")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.showSoftwareResources = true
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Software and resources")])], 1), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "height": "2px"
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('a', {
    attrs: {
      "href": "http://iobio.io/tags/panel.iobio/",
      "target": "_iobio"
    }
  }, [_vm._v("Blog")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('a', {
    attrs: {
      "href": "http://iobio.io/user_guides.html",
      "target": "_iobio"
    }
  }, [_vm._v("Tutorials")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('a', {
    attrs: {
      "href": "http://iobio.io",
      "target": ")iobio"
    }
  }, [_vm._v("iobio")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('a', {
    attrs: {
      "href": "http://iobio.io/blog.html",
      "target": "_iobio"
    }
  }, [_vm._v("iobio Blog")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('a', {
    attrs: {
      "href": "http://iobio.io/support.html",
      "target": ")iobio"
    }
  }, [_vm._v("Support the iobio project")])])], 1)], 1)], 1), _vm._v(" "), (_vm.showDisclaimer) ? _c('NavBarDialogs', {
    attrs: {
      "HeadlineText": _vm.NavBarDialogData[0].HeadlineText,
      "ContentText": _vm.NavBarDialogData[0].Content,
      "id": "DisclaimerDialog"
    },
    on: {
      "closeDialog": function($event) {
        _vm.closeDisclaimer($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAbout) ? _c('NavBarDialogs', {
    attrs: {
      "HeadlineText": _vm.NavBarDialogData[1].HeadlineText,
      "ContentText": _vm.NavBarDialogData[1].Content,
      "id": "AboutDialog"
    },
    on: {
      "closeDialog": function($event) {
        _vm.closeDisclaimer($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSoftwareResources) ? _c('NavBarDialogs', {
    attrs: {
      "HeadlineText": _vm.NavBarDialogData[2].HeadlineText,
      "ContentText": _vm.NavBarDialogData[2].Content,
      "id": "SoftwareResourcesDialog"
    },
    on: {
      "closeDialog": function($event) {
        _vm.closeDisclaimer($event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d7d4b50","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/partials/HelpMenu.vue
// module id = 497
// module chunks = 0